import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, makeSelectNavIsHidden } from '../redux/features/shared/nav';
import { AppState } from '../redux/reducers';

/**
 * Return true when nav is hidden
 * This hook will memoize selector
 * @param menuId
 */
export function useSelectNavIsHidden(menuId: string): boolean {
  const selectNavIsHidden = useMemo(makeSelectNavIsHidden, []);
  return useSelector((state: AppState) => {
    return selectNavIsHidden(state, menuId);
  });
}

export function useNavHideMenuById(menuId: string, isHide = true) {
  const dispatch = useDispatch();
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    dispatch(actions.hideMenu(menuId, isHide));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
}
